import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEmail, requiredString } from '@/utils/zodUtils';

export const AddNewAgentSchema = (t: GetTextIdTranslationType) =>
  z.object({
    username: requiredString(t),
    email: requiredEmail(t),
  });

export type AddNewAgentType = z.infer<ReturnType<typeof AddNewAgentSchema>>;
